import { Tipo_solicitud_def_urb } from './../../../models/tipo_solicitud_def_urb.model';
import { Component } from "@angular/core";

@Component({
    selector: "page-tipo_solicitud_def_urb",
    templateUrl: "./tipo_solicitud_def_urb.component.html",
    styleUrls: ["./tipo_solicitud_def_urb.component.css"]
    
})


export class Tipo_solicitud_def_urbComponent {
    public rows = [];
    public actualRow;
    public tipo_solicitud_def_urb: Tipo_solicitud_def_urb;
    public form;
    public solicitud_def_urb = {"DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)": false, "COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)": false}
    constructor(){
        if(!JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"))){
            localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"));
            this.solicitud_def_urb = { 
             "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)": this.rows[0] ? this.rows[0].solicitud_def_urb["DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)"] : false,
             "COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)": this.rows[0]? this.rows[0].solicitud_def_urb["COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)"] : false

            }
        }
    }

    add_tipo_solicitud_def_urb(){
        localStorage.setItem("tipo_solicitud_def_urb",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_solicitud_def_urb");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            solicitud_def_urb: this.solicitud_def_urb
            
          
        })
        localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_solicitud_def_urb")));
    }
  
    delete_tipo_solicitud_def_urb(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
            }
        }
    }   
}